<div class="ui-modal">
  <div class="header flex-row space-between-center">
    {{ 'ADD_VEHICLE_MODAL.TITLE' | translate }}
    <span class="ui-icon-close c-p" mat-dialog-close></span>
  </div>
  <div class="body flex-col start-start flex dialog-content narrower-input">
    <ng-container *ngIf="loading || (!evaluateResponse && failedFiles.length === 0); else evalResponse">
      <div *ngIf="!selected" class="flex-col center-center gap-16 drag-drop-wrapper" [class.error-msg]="!!errorMsg"
        appDragDropFileUpload (fileDropped)="onFileDrop($event)">
        <div class="flex-row center-center drag-drop-icon icon-16">
          <mat-icon svgIcon="add-image"></mat-icon>
        </div>
        <h2>{{ errorMsg ? errorMsg : ('COMMON.DRAG_DROP' | translate) }}</h2>
        <div class="drag-drop-description">
          {{ 'ADD_VEHICLE_MODAL.ACCEPTED_FILE_TYPES' | translate }}
        </div>
        <ui-button type="primary" [text]="
            errorMsg
              ? ('ADD_VEHICLE_MODAL.ANOTHER_FILE' | translate)
              : ('ADD_VEHICLE_MODAL.FROM_PC' | translate)
          " (clickAction)="fileInput.click()"></ui-button>
        <a href="assets/templates/vehicles-upload-template.csv" download>
          <ui-button type="secondary">{{ 'ADD_VEHICLE_MODAL.DOWNLOAD_TEMPLATE' | translate }}</ui-button>
        </a>
        <div>
          <input #fileInput type="file" hidden multiple name="files" (change)="onFileChange($event)" />
          <!-- <ui-upload #uploadComponent (clickUpload)="upload($event)" [isUploading]="selectIsSaving$ | ngrxPush"></ui-upload> -->
        </div>
      </div>
      <div class="flex-col center-center gap-16 file-list-wrapper p-r" *ngIf="selected">
        <div class="flex-row start-center gap-10 checking-connection-wrapper">
          <mat-spinner diameter="20"></mat-spinner>
          <div class="flex-col gap-8">
            {{ 'COMMON.LOADING' | translate }}
          </div>
        </div>
        <div *ngFor="let file of selectedFiles" class="flex-row start-center gap-8 w-100">
          <div class="flex-row center-center icon-16">
            <mat-icon>file_copy</mat-icon>
          </div>
          <div>{{ file.name }}</div>
        </div>
      </div>
    </ng-container>
    <ng-template #evalResponse>
      <app-file-upload-status [validFiles]="validFiles" [failedFiles]="failedFiles">
      </app-file-upload-status>
    </ng-template>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button *ngIf="!!evaluateResponse" type="default" (clickAction)="reset()">
      {{ 'ADD_VEHICLE_MODAL.BACK_TO_UPLOAD' | translate }}
    </ui-button>
    <ui-button type="primary" (clickAction)="save()">{{ 'COMMON.DONE' | translate }} </ui-button>
  </div>
</div>